import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { motion } from "framer-motion";
//import css
import "swiper/scss";
import "swiper/scss/navigation";
//import required modules
import { Navigation } from "swiper";

const txtVariant = {
  initial: {
    y: "100%",
  },
  animate: {
    y: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 1.5,
    },
  },
};

const imgVariant = {
  initial: {
    clipPath: "inset(100px 50px)",
  },
  animate: {
    clipPath: "inset(0px)",
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 1.8,
    },
  },
};

export default function Services() {
  const [modalImage, setModalImage] = useState(null);

  const openModal = (imageSrc) => {
    setModalImage(imageSrc);
  };

  const closeModal = () => {
    setModalImage(null);
  };
  return (
    <section className="main-section" id="services">
      <div className="subheading">
        <div className="overlay-div">
          <motion.h2
            className="two"
            variants={txtVariant}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
          >
            Products
          </motion.h2>
        </div>
        <div className="overlay-div">
          <motion.h2
            className="three"
            variants={txtVariant}
            initial="initial"
            whileInView="animate"
            viewport={{ once: true }}
          >
            SERVICES
          </motion.h2>
        </div>
      </div>

      <section className="img-showcase">
        <div className="data-info glass-info">
          <div className="overlay-div">
            <motion.h1
              variants={txtVariant}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
            >
              Glass Works
            </motion.h1>
          </div>
          <p>
            We provide professional glass works in Chhatarpur, Delhi, including glass installation, mirror fitting, laminated glass, toughened glass, fluted glass, led mirrors, glass film, frame Mirrors, rollup mesh, sliding mesh and customized glass solutions for homes, shops, and offices.
            <br />
            All types of glass works and mirror solutions available in Chhatarpur, Vasant Kunj & South Delhi.
            <br />
            <br />
            S.N.S. Glass House is known for quality material, proper fitting, and reliable service at reasonable prices.
          </p>
        </div>
        <motion.div
          className="data-img glass-img"
          variants={imgVariant}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
        >
          <Swiper
            modules={[Navigation]}
            navigation={true}
            className="mySwiper"
          >
            {[1, 2, 3, 4].map((num) => (
              <SwiperSlide key={`glass-${num}`}>
                <img
                  src={`./images/glass-${num}.jpeg`}
                  alt="Glass Works"
                  onClick={() => openModal(`./images/glass-${num}.jpeg`)}
                  style={{ cursor: 'pointer' }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>

        {/* BREAk |||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||*/}
        <div className="data-info upvc-info">
          <div className="overlay-div">
            <motion.h1
              variants={txtVariant}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
            >
              UPVC Doors {`&`} Windows
            </motion.h1>
          </div>
          <p>
            We provide premium quality UPVC doors and windows in Chhatarpur, Delhi, designed for durability, noise reduction, and low maintenance.
            Our UPVC solutions offer excellent thermal insulation, weather resistance, and modern aesthetics for homes, shops,  and offices. And we also provide rollup mesh & sliding mesh for upvc windows.
            <br />
            <br />
            Trusted UPVC doors and windows supplier in Chhatarpur, Vasant Kunj & South Delhi.
          </p>
        </div>
        <motion.div
          className="data-img upvc-img"
          variants={imgVariant}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
        >
          <Swiper
            modules={[Navigation]}
            navigation={true}
            className="mySwiper"
          >
            {[1, 2, 3, 4, 5, 6].map((num) => (
              <SwiperSlide key={`upvc-${num}`}>
                <img
                  src={`./images/upvc-${num}.jpeg`}
                  alt="UPVC Mirrors"
                  onClick={() => openModal(`./images/upvc-${num}.jpeg`)}
                  style={{ cursor: 'pointer' }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>

        {/* BREAk |||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||*/}
        <div className="data-info allum-info">
          <div className="overlay-div">
            <motion.h1
              variants={txtVariant}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
            >
              Glass Bricks/Blocks
            </motion.h1>
          </div>
          <p>
            We are a trusted glass bricks and glass blocks supplier in Chhatarpur, Delhi, offering high-quality glass blocks for walls, partitions, windows, and decorative applications.
            Our glass bricks provide natural light, privacy, durability, and a modern look for residential and commercial spaces.
            <br />
            <br />
            Leading glass block and glass brick supplier in Chhatarpur, Vasant Kunj & South Delhi.
          </p>
        </div>
        <motion.div
          className="data-img allum-img"
          variants={imgVariant}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
        >
          <Swiper
            modules={[Navigation]}
            navigation={true}
            className="mySwiper"
          >
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
              <SwiperSlide key={`block-${num}`}>
                <img
                  src={`./images/block-${num}.webp`}
                  alt="Glass Blocks"
                  onClick={() => openModal(`./images/block-${num}.webp`)}
                  style={{ cursor: 'pointer' }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>

        {/* BREAk |||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||*/}
        <div className="data-info rail-info">
          <div className="overlay-div">
            <motion.h1
              variants={txtVariant}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
            >
              Slim Profile Partitions
            </motion.h1>
          </div>
          <p>
            We provide slim profile glass partitions in Chhatarpur, Delhi, ideal for offices, homes, showrooms, and commercial spaces.
            Our slim frame partitions offer maximum light, modern design, and space efficiency with strong, durable glass systems.
            <br />
            <br />
            Trusted slim profile glass partition supplier in Chhatarpur and South Delhi.
          </p>
        </div>
        <motion.div
          className="data-img rail-img"
          variants={imgVariant}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
        >
          <Swiper
            modules={[Navigation]}
            navigation={true}
            className="mySwiper"
          >
            {[1, 2, 3, 4, 5, 6].map((num) => (
              <SwiperSlide key={`slim-${num}`}>
                <img
                  src={`./images/slim-${num}.jpeg`}
                  alt="Slim Partitions"
                  onClick={() => openModal(`./images/slim-${num}.jpeg`)}
                  style={{ cursor: 'pointer' }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>

        {/* BREAk |||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||*/}
        <div className="data-info led-info">
          <div className="overlay-div">
            <motion.h1
              variants={txtVariant}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
            >
              LED Mirrors
            </motion.h1>
          </div>
          <p>We offer modern LED mirrors in Chhatarpur and Vasant Kunj, Delhi, ideal for bathrooms, dressing areas, salons, and vanity spaces.
            Our LED mirrors combine clear reflection, energy-efficient lighting, and stylish designs to enhance both functionality and aesthetics.
            <br />
            <br />
            Trusted LED mirror supplier and installer in Chhatarpur and Vasant Kunj, South Delhi.</p>
        </div>
        <motion.div
          className="data-img led-img"
          variants={imgVariant}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
        >
          <Swiper
            modules={[Navigation]}
            navigation={true}
            className="mySwiper"
          >
            {[1, 2, 3, 4, 5, 6, 7].map((num) => (
              <SwiperSlide key={`led-${num}`}>
                <img
                  src={`./images/led-${num}.jpeg`}
                  alt="LED Mirrors"
                  onClick={() => openModal(`./images/led-${num}.jpeg`)}
                  style={{ cursor: 'pointer' }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>

        {/* BREAk |||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||*/}
        <div className="data-info designer-info">
          <div className="overlay-div">
            <motion.h1
              variants={txtVariant}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
            >
              Shower Cubicles
            </motion.h1>
          </div>
          <p>

            We design and install premium glass shower cubicles in Chhatarpur and Vasant Kunj, Delhi, using high-quality toughened glass for modern and elegant bathrooms.
            Our custom shower cubicles are safe, durable, water-resistant, and designed to give your bathroom a clean, luxury finish.
            <br />
            <br />
            Trusted glass shower cubicle supplier and installer in Chhatarpur and Vasant Kunj, South Delhi.
          </p>
        </div>
        <motion.div
          className="data-img designer-img"
          variants={imgVariant}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
        >
          <Swiper
            modules={[Navigation]}
            navigation={true}
            className="mySwiper"
          >
            {[1, 2, 3, 4, 5, 6, 7].map((num) => (
              <SwiperSlide key={`shower-${num}`}>
                <img
                  src={`./images/shower-${num}.jpeg`}
                  alt="Shower Cubicles"
                  onClick={() => openModal(`./images/shower-${num}.jpeg`)}
                  style={{ cursor: 'pointer' }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>

        {/* BREAk |||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||*/}
        <div className="data-info frame-info">
          <div className="overlay-div">
            <motion.h1
              variants={txtVariant}
              initial="initial"
              whileInView="animate"
              viewport={{ once: true }}
            >Frame Mirrors</motion.h1>
          </div>
          <p>
            We offer premium designer frame mirrors in Chhatarpur and Vasant Kunj, Delhi, crafted to enhance modern and classic interiors.
            Our framed mirrors are available in antique, golden, rose gold, and custom finishes, perfect for adding elegance and depth to any space.
            <br />
            <br />
            Trusted designer frame mirror supplier and installer in Chhatarpur and Vasant Kunj, South Delhi.
          </p>
        </div>
        <motion.div
          className="data-img frame-img"
          variants={imgVariant}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
        >
          <Swiper
            modules={[Navigation]}
            navigation={true}
            className="mySwiper"
          >
            {[1, 2, 3, 4, 5].map((num) => (
              <SwiperSlide key={`frame-${num}`}>
                <img
                  src={`./images/frame-${num}.jpeg`}
                  alt="Frame Mirrors"
                  onClick={() => openModal(`./images/frame-${num}.jpeg`)}
                  style={{ cursor: 'pointer' }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      </section>
      {/* BREAk |||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||||*/}

      {/* Image Modal */}
      {modalImage && (
        <div className="image-modal unpadded" onClick={closeModal}>
          <div className="image-modal__content" onClick={(e) => e.stopPropagation()}>
            <button className="image-modal__close" onClick={closeModal}>
              &times;
            </button>
            <img src={modalImage} alt="Preview" />
          </div>
        </div>
      )}
    </section>
  );
}
